import { createTheme } from "@mui/material";
import { indigo } from "@mui/material/colors";

export const theme = createTheme({
    components: {
        MuiButton: {
            defaultProps: {
                disableRipple: true
            },
            styleOverrides: [
                {

                }
            ],
            variants: [
                {
                    props: {
                        variant: 'titleOption'
                    },
                    style: {
                        color: `white`,
                        textTransform: 'none',
                    }
                },
                {
                    props: {
                        variant: 'outline-rounded-black'
                    },
                    style: {
                        textTransform: 'none',
                        color: 'white',
                        fontSize: '0.8rem',
                        minHeight: 0,
                        borderRadius: '12px',
                        padding: '4px 8px',
                        fontSize: '0.7rem',
                        minHeight: 0,
                        minWidth: 0,
                        backgroundColor: indigo['300'],
                    }
                },
                {
                    props: {
                        variant: 'text-button'
                    },
                    style: {
                        textTransform: 'none',
                        color: 'black',
                        borderRadius: '12px',
                        padding: '4px 4px',
                        fontSize: '0.7rem',
                        minHeight: 0,
                        minWidth: 0,
                    }
                },
                {
                    props: {
                        variant: 'indigo-100-text-button'
                    },
                    style: {
                        textTransform: 'none',
                        background: indigo['100'],
                        border: '2px solid black',
                        borderRadius: '12px',
                        padding: '4px 4px',
                        fontSize: '0.7rem',
                        minHeight: 0,
                        minWidth: 0,
                        color: 'black',
                    }
                },
                {
                    props: {
                        variant: 'indigo-300-text-button'
                    },
                    style: {
                        textTransform: 'none',
                        background: indigo['300'],
                        border: '2px solid black',
                        borderRadius: '12px',
                        padding: '4px 4px',
                        fontSize: '0.7rem',
                        minHeight: 0,
                        minWidth: 0,
                        color: 'black',
                    }
                }
            ]
        },
        MuiIconButton: {
            defaultProps: {
                disableRipple: true,
            },
            variants: [

            ]
        },
        MuiTypography: {
            variants: [
                {
                    props: {
                        variant: 'whatsapp-template-content'
                    },
                    style: {
                        color: '#ffffff',
                    }
                },
                {
                    props: {
                        variant: 'attribute'
                    },
                    style: {
                        fontWeight: 'bold'
                    }
                },
                {
                    props: {
                        variant: 'section-header'
                    },
                    style: {
                        fontWeight: 'bold',
                        fontSize:'1rem',
                    }
                }
            ]
        },
        MuiCheckbox: {
            variants: [
                {
                    props: {
                        variant: 'no-padding'
                    },
                    style: {
                        padding: 0,
                    }
                }
            ]
        }
    }
});